module.exports = __webpack_public_path__ + "img/BE0643865313.8c34ea04.png";